"use client";

import { CloseButton, Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { X } from "@phosphor-icons/react/dist/ssr";
import React, { type PropsWithChildren } from "react";

interface PopupProps {
  isOpen?: boolean;
  onClose: () => void;
}

const Popup = ({ children, isOpen = false, onClose }: PropsWithChildren<PopupProps>) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 text-white">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-black px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <CloseButton onClick={onClose} className="absolute opacity-60 top-0 right-0 mt-4 mr-4">
              <X className="h-6 w-6" />
            </CloseButton>
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default Popup;
